export default __webpack_public_path__ + "static/media/ford.526b7a22.webp";